var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tk-container',{attrs:{"status":_vm.status}},[_c('tk-flex',{staticClass:"w-full h-full p-15",attrs:{"middle":""}},[_c('div',{staticClass:"w-full"},[(_vm.question)?_c('QuestionContent',{attrs:{"question":_vm.question,"is-fullscreen":_vm.isFullscreen,"compact":true},on:{"complete":_vm.handleComplete}}):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }